var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","fillRule":"evenodd","stroke":"#FFF","strokeLinecap":"square","strokeWidth":"2","d":"M9.591 1.73l-3.86 3.86-3.862-3.86"}));
}

Chevron.defaultProps = {"width":"11px","height":"7px"};

module.exports = Chevron;

Chevron.default = Chevron;
